import { RootState } from 'store'
export const toastsSelector = (state: RootState) => state.toast.value
